<!--  Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved  -->

<div class="notification-container {{position || 'bottom right'}}">
  @for (notification of notifications.slice(0, 6); track notification) {
    <app-notification
    [notification]="notification" (onClose)="close(notification)"></app-notification>
  }
</div>